export default "__VITE_ASSET__329coPVN__"